export const userConfig = [
  {
    id: 1,
    formName: "pro_contact_name",
    placeHolder: "contact_name",
  },
  {
    id: 2,
    formName: "pro_status_id",
    placeHolder: "status",
  },
  {
    id: 3,
    formName: "pro_contact_email",
    placeHolder: "contact_email",
  },
  {
    id: 4,
    formName: "pro_contact_phone",
    placeHolder: "contact_phone",
  },

  {
    id: 5,
    formName: "pro_address",
    placeHolder: "address",
  },
];

export const statusOption = [
  { lable: "Concept_Stage", id: 1 },
  { lable: "Building_stage", id: 2 },
  { lable: "Growth_Stage", id: 3 },
];

export const planetButtonConfig = (
  liked: any,
  authDetails: any,
  planetData: any,
) => {
  const isEngage = planetData?.is_engaged ;
  const isInviteCitizen =
  planetData?.pro_owner === authDetails?.user_details.usr_id ||
    authDetails?.isAdmin;
  
  const planetAccess =planetData?.pro_access
const isAdmin =planetData?.isAdmin

const engaged =planetData?.is_engaged
  const btnconfig = [
    {
      id: !authDetails?.authToken ? 6 : 1,
      // id:isEngage?1:2,
      label: "like",
      icon: liked ? "favorite" : "favorite_border",
      iconType: "icons",
      color: "red",
      visible: true,
    },
    
    {
      id:  !authDetails?.authToken ? 6 : 2,
      label: "engage",
      icon:  "volunteer_activism",
      iconStyle:'outlined',
      iconType: "icons",
      color:  "skyblue",
      visible:!isAdmin && !engaged && (planetAccess === 0 || planetAccess === 4 || planetAccess ===3),
    },
    {
      id: 7,
      label: "engage",
      icon:  "volunteer_activism",
      iconStyle: null ,
      iconType: "icons",
      color:  "skyblue",
      visible: engaged  ,
    },
    // {
    //   id: 3,
    //   label: "insta_heal",
    //   icon: "universal_currency_alt",
    //   iconType: "symbols",
    //   color: "bright_green",
    //   visible:  true,
    // },
    {
      id: 4,
      label: "invite_citizen",
      icon: "person_add",
      iconType: "icons",
      color: "purple",
      visible: isAdmin || planetAccess ===1  || planetAccess ===2? true : false,
    },
     {
      id: 8,
      label: "join_planet",
      icon: "device_hub",
      iconType: "icons",
      color: "green",
      visible: (planetAccess === 4 || planetAccess ===3 || planetAccess ===0) ?true : false,
    },
    {
      id: 5,
      label: "drop",
      icon: "delete",
      iconType: "icons",
      color: "red",
      visible: isAdmin || planetAccess ===1  ? true : false,
    },
    {
      id: 9,
      label: "share",
      icon: "share",
      iconType: "icons",
      color: "skyblue",
      visible: true,
    },
  ];

  return btnconfig;
};

export const btnConfig = [
  { label: 'no', value: false },
  { label: 'yes', value: true },
]
